import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxDeeplinkerService } from 'ngx-deeplinker';
import { MixPanelService } from 'src/app/shared/services/mixpanel.service';

export interface ExitCreateDialogData {
  currentSection: number;
  selectedId: string;
  userId: string;
  isCreated: boolean;
  sectionSaved: boolean;
  sectionHasChanged: boolean;
}

@Component({
  selector: 'app-exit-create-dialog',
  templateUrl: './exit-create-dialog.component.html',
  styleUrls: ['./exit-create-dialog.component.scss'],
})
export class ExitCreateDialogComponent {
  dialogState = 'DEFAULT';
  currentSection = '';
  selectedId = '';
  userId = '';
  appPrefix = 'usr';
  sectionsLabels = [
    'user.stepper.identification',
    'user.stepper.roles',
    'user.stepper.contact',
    'user.stepper.sync',
    'user.stepper.settings',
  ];
  isCreated = false;

  constructor(
    public dialogRef: MatDialogRef<ExitCreateDialogComponent>,
    private ngxDeeplinkerService: NgxDeeplinkerService,
    private router: Router,
    private mixpanelService: MixPanelService, 
    @Inject(MAT_DIALOG_DATA) public data: ExitCreateDialogData,
  ) {
    this.currentSection = this.sectionsLabels[this.data.currentSection];
    this.selectedId = this.data.selectedId;
    this.userId = this.data.userId;
    this.isCreated = this.data.isCreated;
  }

  onClick(): void {
    this.dialogRef.close();
    this.mixpanelService.userCreateExitButton();
    this.ngxDeeplinkerService.returnHandler({ appPrefix: this.appPrefix });
    if (this.userId) {
      this.router.navigate([`details/${this.userId}/view`], {});
    } else if (this.selectedId) {
      this.router.navigate([`details/${this.selectedId}/view`], {});
    } else {
      this.router.navigate(['/']);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
